export type ClientUnreadSection = 'messages' | 'quote' | 'status';

const CLIENT_UNREAD_SECTION_PRIORITY: ClientUnreadSection[] = ['quote', 'messages', 'status'];

export const mapLegacyClientUnreadTypeToSection = (
  type: string | null | undefined
): ClientUnreadSection | null => {
  switch (type) {
    case 'message':
      return 'messages';
    case 'quote':
      return 'quote';
    case 'status_change':
      return 'status';
    default:
      return null;
  }
};

export const normalizeClientUnreadSections = (
  value: unknown,
  legacyType?: string | null
): ClientUnreadSection[] => {
  const rawSections = Array.isArray(value) ? value : [];
  const normalized = rawSections
    .map((entry) => String(entry || '').trim())
    .filter(
      (entry): entry is ClientUnreadSection =>
        entry === 'messages' || entry === 'quote' || entry === 'status'
    );
  const legacySection = mapLegacyClientUnreadTypeToSection(legacyType || null);
  const merged = legacySection ? [...normalized, legacySection] : normalized;
  return Array.from(new Set(merged));
};

export const getPrimaryClientUnreadSection = (
  sections: ClientUnreadSection[]
): ClientUnreadSection | null => {
  for (const section of CLIENT_UNREAD_SECTION_PRIORITY) {
    if (sections.includes(section)) {
      return section;
    }
  }
  return null;
};

export const getSecondaryClientUnreadSection = (
  sections: ClientUnreadSection[],
  primary: ClientUnreadSection | null
): ClientUnreadSection | null => {
  const candidates = primary ? sections.filter((section) => section !== primary) : sections;
  for (const section of CLIENT_UNREAD_SECTION_PRIORITY) {
    if (candidates.includes(section)) {
      return section;
    }
  }
  return null;
};

export const getClientUnreadLegacyType = (
  sections: ClientUnreadSection[]
): 'message' | 'quote' | 'status_change' | null => {
  const primary = getPrimaryClientUnreadSection(sections);
  if (!primary) return null;
  if (primary === 'quote') return 'quote';
  if (primary === 'messages') return 'message';
  return 'status_change';
};
